import { render, staticRenderFns } from "./HomeItem.vue?vue&type=template&id=bb5d2874&scoped=true&"
import script from "./HomeItem.vue?vue&type=script&lang=js&"
export * from "./HomeItem.vue?vue&type=script&lang=js&"
import style0 from "./HomeItem.vue?vue&type=style&index=0&id=bb5d2874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5d2874",
  null
  
)

export default component.exports